import React from "react";

export const CasesEmergeny = () => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 6.04667C14.6067 6.23333 14.6667 6.44667 14.6667 6.66667C14.6667 6.88667 14.6067 7.1 14.5 7.28667L11.3867 12.6667C11.1467 13.08 10.7067 13.3333 10.2333 13.3333H4.43333C3.96 13.3333 3.52 13.08 3.28 12.6667L0.166667 7.28667C0.06 7.1 0 6.88667 0 6.66667C0 6.44667 0.06 6.23333 0.166667 6.04667L3.28 0.666667C3.52 0.253333 3.96 0 4.43333 0H10.2333C10.7067 0 11.1467 0.253333 11.3867 0.666667L14.5 6.04667ZM7.33333 6.66667V6.6L5.61333 3.4L5.5 3.33333H4.44L4.33333 3.4V3.53333L6 6.66667L4.33333 9.8V9.93333L4.44 10H5.5L5.61333 9.93333L7.33333 6.73333V6.66667L7.35333 6.73333L9.05333 9.93333L9.16667 10H10.2267L10.3333 9.93333V9.8L8.66667 6.66667L10.3333 3.53333V3.4L10.2267 3.33333H9.16667L9.05333 3.4L7.35333 6.6L7.33333 6.66667Z" fill="#E2231A"/>
    </svg>
    
  );
};

export default CasesEmergeny;
